<template lang="pug">
  .presence-panel
    .head
      div.dateDisplay(v-if="day" )
        .button.dateButton(@click="changeDate()" v-if="user.is_board_member || user.can_lookup_shift_times ") <
        span {{day.date|moment("DD. MM. YYYY")}}
        .button.dateButton(@click="changeDate(true)" :disabled="isToday" v-if="user.is_board_member || user.can_lookup_shift_times") >
      div.events(v-if="day")
        div.event(v-for="event in day.events")
          template(v-if="!event.canceled")
            span {{event.badge}}:
            span  {{event.name}}
        div(v-if="day.events.length == 0" ) heute keine Veranstaltung

      .presence-user.header(v-if="day && day.events.length != 0")
        .item
        .item
          strong Start
        .item
          strong Ende
    .list
      .shift-type(v-for="(shift, index) in shifts" :class="{'dark-bg': index % 2}")
        presence-list(:shift="shift" @refresh="loadShifts()" :user="user")
</template>

<script>
export default {
  name: 'presence-panel',
  props: ['user'],
  data () {
    return {
      day: undefined,
      date: new Date(),
      shifts: {},
      loginToken: this.$localStorage.get('loginToken')
    }
  },
  methods: {
    loadShifts () {
      let url = '/shift-times/?date=' + this.date.toISODate()
      this.$http.get(url)
          .set({Authorization: 'jwt ' + this.loginToken})
          .then(res => {
            this.shifts = res.body
          })
          .catch((err, data) => {
            console.log(err)
          })
    },
    loadDay () {
      let url = '/admin/get-day?date=' + this.date.toISODate()
      this.$http.get(url)
          .set({Authorization: 'jwt ' + this.loginToken})
          .then(res => {
            this.day = res.body
          })
          .catch((err, data) => {
            console.log(err)
          })
    },
    changeDate (next) {
      const step = next ? 1 : -1
      this.date = new Date(this.date.setDate(this.date.getDate() + step))
      this.loadDay()
      this.loadShifts()
    }
  },
  created () {
    this.loadShifts()
    this.loadDay()
  },
  computed: {
    isToday () {
      const reference = this.date.toISODate()
      const today = (new Date()).toISODate()
      return reference === today
    }
  }
}
</script>


<style scoped lang="sass">
.head
  display: grid
  padding-left: 16px
  padding-right: 16px
  grid-template-rows: 3em 3em 2em

.list
  overflow-x: hidden
  overflow-y: auto
.presence-panel
  display: grid
  grid-template-rows: 117px  1fr
  height: 100%

.dateDisplay
  display: flex
  justify-content: space-between
  align-items: center
  // justify-items: center
  width: 150px

.event
  display: grid
  grid-template-columns: 70px 1fr

.dateButton, .dateButton:hover, .dateButton:active
  border: none
  box-shadow: none
  &[disabled]
    background-color: white
    color: white
.dark-bg
  background-color: #f1f1f1

</style>



// WEBPACK FOOTER //
// PresencePanel.vue?591c4329